import React from 'react';
import { Icon } from '../icons';

/**
 * KpiTile — single key-metric tile.
 *
 * Props:
 *   label: string
 *   value: ReactNode
 *   meta:  ReactNode (optional secondary line)
 *   trend: { direction: 'up' | 'down', value: string|number, label?: string } (optional)
 */
const KpiTile = ({ label, value, meta, trend, className = '', children, ...rest }) => (
  <div className={`ps-kpi ${className}`.trim()} {...rest}>
    {label && <span className="ps-kpi__label">{label}</span>}
    {value != null && <span className="ps-kpi__value tabular">{value}</span>}
    {(meta || trend) && (
      <span className="ps-kpi__meta">
        {trend && (
          <span className={`ps-kpi__trend ps-kpi__trend--${trend.direction}`}>
            {trend.direction === 'up' ? <Icon.ArrowUp size={12} /> : <Icon.ArrowDown size={12} />}
            {trend.value}
            {trend.label ? ` ${trend.label}` : ''}
          </span>
        )}
        {trend && meta ? ' · ' : ''}
        {meta}
      </span>
    )}
    {children}
  </div>
);

export default KpiTile;
